module.exports = __webpack_public_path__ + "img/cartao_agenda.58ff4e75.svg";